import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { map, concatMap, tap } from 'rxjs/operators';
import { OrigamiUrlsParams } from '@app/origami-api/constants';
import { SessionService } from '@app/session/session.service';
import { AuthService } from '@app/services';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfidentialityAgreementModuleGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionService: SessionService,
  ) {}

  canActivate = (route: ActivatedRouteSnapshot) => {
    return this.authService.checkSession().pipe(
      concatMap((res) => {
        if (res.hasSession && !res.registrationMode) {
          return this.sessionService.enterDomain().pipe(map(() => true));
        }
        return of(false);
      }),
      tap((loggedIn) => this.goToAlterUrl({ loggedIn: loggedIn, url: route.url.join('/') })),
    );
  };

  canDeactivate = () => this.sessionService.leaveDomain().pipe(map(() => true));

  canLoad = () =>
    this.authService.checkSession().pipe(
      map((auth) => auth.hasSession && !auth.registrationMode),
      tap((loggedIn) => this.goToAlterUrl({ loggedIn: loggedIn })),
    );

  private goToAlterUrl(auth: { loggedIn: boolean; url?: string }) {
    if (!auth.loggedIn) {
      const queryParams = auth.url ? { [OrigamiUrlsParams.returnRoute]: escape(auth.url) } : {};
      this.router.navigate(['/auth'], { queryParams: queryParams });
    }
  }
}
